export const isProductionEnvironment = (): boolean => {
  if (typeof import.meta?.env === 'undefined') {
    return false;
  }

  return import.meta.env.PROD === true;
};

export const isNotProductionEnvironment = (): boolean => !isProductionEnvironment();

export const isDevelopmentEnvironment = (): boolean => {
  if (typeof import.meta?.env === 'undefined') {
    return true;
  }

  return import.meta.env.DEV === true;
};
